import request, { ResponseData } from '@/utils/request'
import { InformationList } from './data.d'

interface Params {
  page: {
    page_size: number
    page_num?: number
  }
  cnick?: string
  name?: string
  begin_timestamp?: number
  end_timestamp?: number
  task_execute_record_id?: string
}

export async function fetchInformationList(params: Params): Promise<ResponseData<InformationList>> {
  return request('/api/v1/training/dialog_result/list', {
    method: 'post',
    data: params,
  })
}

export async function dialogDetail(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/detail', {
    method: 'post',
    data: params,
  })
}

export async function taskList(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/execute_record', {
    method: 'post',
    data: params,
  })
}

export async function exportRecording(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/execute_record/export', {
    method: 'post',
    data: params,
    responseType: 'arrayBuffer',
    getResponse: true,
  })
}

export async function scoreModify(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/score_modify', {
    method: 'post',
    data: params,
  })
}

export async function detailScoreModify(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/detail/score_modify', {
    method: 'post',
    data: params,
  })
}

export async function editQuality(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/storycase/qc_update', {
    method: 'post',
    data: params,
  })
}

export async function searchRecord(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/execute_record_detail', {
    method: 'post',
    data: params,
  })
}

export async function exportDetail(params): Promise<ResponseData<null>> {
  return request('/api/v1/training/dialog_result/execute_record_detail/export', {
    method: 'post',
    data: params,
    responseType: 'arrayBuffer',
    getResponse: true,
  })
}
